(() => {
  if (customElements.get('lp-navigation')) return;
  const esc = value => String(value ?? '').replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
  const svg = (paths, cls = '', size = 12) => `<svg class="lp-nav-ic ${cls}" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" aria-hidden="true">${paths}</svg>`;
  const arrow = svg('<path d="M2 6h8M6.5 2.5 10 6l-3.5 3.5"/>', 'lp-nav-arrow');
  const smallArrow = arrow.replace('lp-nav-arrow', '');
  const chev = svg('<path d="M2 3.5 5 6.5 8 3.5"/>', 'lp-nav-chev', 10);
  const mobileChev = svg('<path d="M3 5l4 4 4-4"/>', 'lp-nav-chev', 14);
  const plus = svg('<path d="M2.5 7h9"/><path class="lp-nav-v" d="M7 2.5v9"/>', '', 14);
  const safeUrl = url => /^(https?:\/\/|\/|#|mailto:|tel:)/i.test(url || '') ? url : '#';
  const a = (url, text, cls = '') => `<a href="${esc(safeUrl(url))}"${cls ? ` class="lp-nav-${cls}"` : ''}>${text}</a>`;
  class LeafNavigation extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const data = this.querySelector('[data-lp-menu-data]');
      try { this.menus = JSON.parse(data?.textContent || ''); } catch {
        if (!this.pendingObserver) {
          this.pendingObserver = new MutationObserver(() => this.connectedCallback());
          this.pendingObserver.observe(this, { childList: true, subtree: true, characterData: true });
        }
        return;
      }
      this.pendingObserver?.disconnect(); this.pendingObserver = null;
      this.controller = new AbortController();
      const on = (node, event, handler) => node?.addEventListener(event, handler, { signal: this.controller.signal });
      this.nav = this.querySelector('.lp-nav-nav');
      this.panel = this.querySelector('.lp-nav-panel');
      this.scrim = this.querySelector('.lp-nav-scrim');
      this.drawer = this.querySelector('.lp-nav-drawer');
      this.list = this.querySelector('.lp-nav-drawer-list');
      this.header = this.closest('.section-header');
      this.trigger = this.header.querySelector('[data-lp-nav-trigger]');
      this.active = -1; this.cat = -1; this.group = ''; this.mobileOpen = false;
      this.nav.innerHTML = this.menus.map((m, i) => m.g.length || m.p.length || m.q.length ? `<button type="button" class="lp-nav-nav-btn" data-lp-top="${i}" ${m.blockId ? `data-shopify-editor-block="${esc(JSON.stringify({id:m.blockId,type:'nav_panel'}))}"` : ''} aria-expanded="false" aria-controls="${this.panel.id}"><span>${esc(m.l)}</span>${chev}<span class="lp-nav-bar"></span></button>` : a(m.url, esc(m.l), 'nav-btn')).join('');
      this.buttons = [...this.nav.querySelectorAll('[data-lp-top]')];
      this.buttons.forEach(b => {
        const i = Number(b.dataset.lpTop);
        on(b, 'click', () => this.active === i ? this.closePanel() : this.openPanel(i));
        on(b, 'mouseenter', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.openPanel(i), this.active < 0 ? 150 : 90); });
        on(b, 'mouseleave', () => clearTimeout(this.timer));
        on(b, 'keydown', e => {
          if (e.key === 'ArrowDown') { e.preventDefault(); this.openPanel(i); this.panel.querySelector('a')?.focus(); }
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); const j = (this.buttons.indexOf(b) + (e.key === 'ArrowRight' ? 1 : this.buttons.length - 1)) % this.buttons.length;
            this.openPanel(Number(this.buttons[j].dataset.lpTop)); this.buttons[j].focus();
          }
        });
      });
      const cancelClose = () => clearTimeout(this.closeTimer);
      const scheduleClose = () => {
        cancelClose();
        if (innerWidth < 1100 || this.active < 0) return;
        if (window.Shopify?.designMode && LeafNavigation.selectedBlock) return;
        this.closeTimer = setTimeout(() => this.closePanel(), 180);
      };
      on(this.nav, 'mouseenter', cancelClose);
      on(this.nav, 'mouseleave', scheduleClose);
      on(this.panel, 'mouseenter', cancelClose);
      on(this.panel, 'mouseleave', scheduleClose);
      on(this.scrim, 'mouseenter', scheduleClose);
      on(this.scrim, 'click', () => this.closePanel());
      on(this.trigger, 'click', () => this.toggleDrawer(!this.mobileOpen));
      on(this.list, 'click', e => {
        const cat = e.target.closest('[data-cat]'), group = e.target.closest('[data-group]');
        if (cat) {
          const i = Number(cat.dataset.cat); this.cat = this.cat === i ? -1 : i; this.group = this.cat < 0 ? '' : `${i}:0`;
          this.renderDrawer(); this.list.querySelector(`[data-cat="${i}"]`)?.focus({ preventScroll: true });
        } else if (group) {
          const key = group.dataset.group; this.group = this.group === key ? '' : key;
          this.renderDrawer(); this.list.querySelector(`[data-group="${key}"]`)?.focus({ preventScroll: true });
        }
      });
      on(this.drawer, 'click', e => { if (e.target.closest('a')) this.toggleDrawer(false, false); });
      on(document, 'keydown', e => {
        if (e.key === 'Escape') {
          if (this.active >= 0) { const b = this.buttons.find(b => Number(b.dataset.lpTop) === this.active); this.closePanel(); b?.focus(); }
          if (this.mobileOpen) this.toggleDrawer(false);
        }
        if (e.key === 'Tab' && this.mobileOpen) {
          const focusable = [this.trigger, ...this.drawer.querySelectorAll('a[href],button')].filter(el => el.getClientRects().length);
          const first = focusable[0], last = focusable.at(-1);
          if (e.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) { e.preventDefault(); first.focus(); }
        }
      });
      on(document, 'focusin', e => { if (!window.Shopify?.designMode && this.active >= 0 && !this.contains(e.target)) this.closePanel(); });
      on(window, 'resize', () => { if (innerWidth >= 1100) this.toggleDrawer(false, false); else this.closePanel(); this.revealSelected(); this.position(); });
      on(window, 'scroll', () => this.position());
      this.observer = new ResizeObserver(() => this.position()); this.observer.observe(this.header);
      on(document, 'shopify:block:select', e => {
        const i = this.menus.findIndex(m => m.blockId === e.detail?.blockId);
        if (i < 0) return;
        LeafNavigation.selectedBlock = e.detail.blockId;
        this.revealSelected();
      });
      on(document, 'shopify:block:deselect', e => {
        if (!this.menus.some(m => m.blockId === e.detail?.blockId)) return;
        if (LeafNavigation.selectedBlock !== e.detail.blockId) return;
        LeafNavigation.selectedBlock = null;
        this.closePanel(); this.toggleDrawer(false, false);
      });
      this.revealSelected();
    }
    revealSelected() {
      const i = this.menus.findIndex(m => m.blockId && m.blockId === LeafNavigation.selectedBlock);
      if (i < 0) return;
      if (innerWidth >= 1100) this.openPanel(i);
      else { this.cat = i; this.group = i + ':0'; this.toggleDrawer(true); this.renderDrawer(); }
    }
    columns(m) {
      const used = new Set();
      const cols = (m.columns || '').split('|').map(col => col.split(',').map(v => Number(v.trim()) - 1).filter(i => {
        if (!Number.isInteger(i) || i < 0 || i >= m.g.length || used.has(i)) return false;
        used.add(i); return m.g[i][2].length > 0;
      }).map(i => m.g[i])).filter(col => col.length);
      m.g.forEach((g, i) => { if (!used.has(i) && g[2].length) cols.push([g]); });
      return cols;
    }
    panelHtml(m) {
      const cols = this.columns(m), more = m.g.filter(g => !g[2].length);
      let h = '<div class="lp-nav-panel-inner">';
      if (cols.length || more.length) {
        h += `<div class="lp-nav-groups" style="grid-template-columns:repeat(${cols.length + (more.length ? 1 : 0)},auto)">`;
        h += cols.map(col => '<div class="lp-nav-col">' + col.map(g => `<div class="lp-nav-g">${a(g[1], esc(g[0]) + arrow, 'g-h')}<ul>${g[2].map(it => `<li>${a(it[1], esc(it[0]))}</li>`).join('')}</ul></div>`).join('') + '</div>').join('');
        if (more.length) h += '<div class="lp-nav-more">' + more.map(g => a(g[1], esc(g[0]) + arrow, 'g-h')).join('') + '</div>';
        h += '</div>';
      }
      if (m.p.length) h += `<div class="lp-nav-photos" style="grid-template-columns:repeat(${m.p.length},196px)">` + m.p.map(p => a(p[1], `<div class="lp-nav-img"><img src="${esc(p[2])}" alt="${esc(p[3])}" width="392" height="490" loading="lazy"></div><div class="lp-nav-t">${esc(p[0])}</div><span class="lp-nav-shop">${esc(this.dataset.shopLabel)}${smallArrow}</span>`, 'card')).join('') + '</div>';
      h += '</div>';
      if (m.q.length) h += `<div class="lp-nav-quick-wrap"><nav class="lp-nav-quick" aria-label="${esc(this.dataset.quickLabel)}">` + m.q.map(q => a(q[1], esc(q[0]) + smallArrow)).join('') + '</nav></div>';
      return h;
    }
    openPanel(i) {
      if (innerWidth < 1100 || !this.menus[i]) return;
      clearTimeout(this.closeTimer); clearTimeout(this.timer); this.active = i;
      this.panel.innerHTML = this.panelHtml(this.menus[i]); this.panel.setAttribute('aria-label', this.menus[i].l);
      this.panel.hidden = false; this.scrim.hidden = false; this.panel.scrollTop = 0;
      this.buttons.forEach(b => { const on = Number(b.dataset.lpTop) === i; b.classList.toggle('lp-nav-is-on', on); b.setAttribute('aria-expanded', String(on)); });
      this.position();
    }
    closePanel() {
      clearTimeout(this.closeTimer); clearTimeout(this.timer); this.active = -1;
      this.panel.hidden = true; this.scrim.hidden = true;
      this.buttons.forEach(b => { b.classList.remove('lp-nav-is-on'); b.setAttribute('aria-expanded', 'false'); });
    }
    renderDrawer() {
      const scroll = this.list.scrollTop;
      this.list.innerHTML = this.menus.map((m, i) => {
        if (!m.g.length && !m.p.length && !m.q.length) return `<div class="lp-nav-cat">${a(m.url, esc(m.l), 'cat-btn')}</div>`;
        const on = i === this.cat, id = `lp-cat-${this.dataset.sectionId}-${i}`;
        let h = `<div class="lp-nav-cat"><button type="button" class="lp-nav-cat-btn${on ? ' lp-nav-is-on' : ''}" data-cat="${i}" aria-expanded="${on}" aria-controls="${id}"><span>${esc(m.l)}</span>${mobileChev}</button><div id="${id}"${on ? '' : ' hidden'}>`;
        if (on) {
          h += '<div class="lp-nav-cat-body">';
          if (m.p.length) h += '<div class="lp-nav-m-photos">' + m.p.map(p => a(p[1], `<img src="${esc(p[2])}" alt="${esc(p[3])}" width="152" height="114" loading="lazy"><span>${esc(p[0])}</span>`)).join('') + '</div>';
          if (m.g.length) h += '<div class="lp-nav-m-groups">' + m.g.map((g, j) => {
            if (!g[2].length) return a(g[1], esc(g[0]) + smallArrow, 'grp-link');
            const key = `${i}:${j}`, expanded = this.group === key, gid = `lp-group-${this.dataset.sectionId}-${i}-${j}`;
            return `<div><button type="button" class="lp-nav-grp-btn${expanded ? ' lp-nav-is-on' : ''}" data-group="${key}" aria-expanded="${expanded}" aria-controls="${gid}"><span>${esc(g[0])}</span>${plus}</button><ul id="${gid}" class="lp-nav-grp-items"${expanded ? '' : ' hidden'}><li>${a(g[1], esc(this.dataset.allLabel) + ' ' + esc(g[0]) + smallArrow, 'all')}</li>${g[2].map(it => `<li>${a(it[1], esc(it[0]))}</li>`).join('')}</ul></div>`;
          }).join('') + '</div>';
          const cta = this.drawer.querySelector('.lp-nav-cta');
          const quick = m.q.filter(q => !cta || new URL(q[1], location.origin).pathname !== new URL(cta.href).pathname);
          if (quick.length) h += '<div class="lp-nav-chips">' + quick.map(q => a(q[1], esc(q[0]))).join('') + '</div>';
          h += '</div>';
        }
        return h + '</div></div>';
      }).join('');
      this.list.scrollTop = scroll;
    }
    toggleDrawer(open, focus = true) {
      if (open === this.mobileOpen) return;
      this.mobileOpen = open; this.toggleAttribute('data-mobile-open', open); this.drawer.hidden = !open;
      this.trigger.setAttribute('aria-expanded', String(open)); this.trigger.setAttribute('aria-label', open ? this.dataset.closeLabel : this.dataset.openLabel);
      this.trigger.querySelector('path').setAttribute('d', open ? 'M5 5l12 12M17 5 5 17' : 'M3 6h16M3 11h16M3 16h16');
      if (open) {
        this.previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
        this.renderDrawer(); this.position();
      } else {
        document.body.style.overflow = this.previousOverflow || ''; if (focus) this.trigger.focus();
      }
    }
    position() {
      if (this.active >= 0) this.style.setProperty('--lp-panel-top', `${Math.max(0, this.nav.getBoundingClientRect().bottom)}px`);
      if (this.mobileOpen) this.style.setProperty('--lp-drawer-top', `${Math.max(0, this.getBoundingClientRect().top)}px`);
    }
    disconnectedCallback() {
      this.pendingObserver?.disconnect(); this.pendingObserver = null;
      clearTimeout(this.closeTimer); clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); this.controller = null;
      if (this.mobileOpen) document.body.style.overflow = this.previousOverflow || '';
    }
  }
  customElements.define('lp-navigation', LeafNavigation);
})();
